module.exports = __webpack_public_path__ + "static/media/grays1.2835f798.png";